
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ontology-of-being",
      function () {
        return require("private-next-pages/ontology-of-being/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ontology-of-being"])
      });
    }
  